<div resizeObserver (resize)="onResize($event.contentRect?.width)">
    <app-resources-sub-grid-base
        [tableFilterItems]="tableFilterItems"
        [showOccasion]="showOccasion"
        [resBlockWidth]="resBlockWidth"
        [hasThumbnailHoverEffect]="hasThumbnailHoverEffect"
        [label]="label"
        [guestMode]="guestMode"
        [pageEvent]="pageEvent"
        [loadMoreOnScroll]="loadMoreOnScroll"
        (onPaginatorPageChange)="onPaginatorPageChange.emit($event)"
    ></app-resources-sub-grid-base>
</div>
